import { DataPoint } from './dataPoint';
import { DataPointLabel } from './dataPointLabel';
import { ChartAreaProps } from './types';

export const ChartArea = ({
  margin,
  clipPathUrl,
  renderedDataPoints,
  renderedLabels,
}: ChartAreaProps) => (
  <g
    clipPath={`url(#${clipPathUrl})`}
    transform={`translate(${margin.left}, ${margin.top})`}
  >
    {renderedDataPoints.map(scaledDataPoint => (
      <DataPoint key={scaledDataPoint.uniqueId} data={scaledDataPoint} />
    ))}
    {renderedLabels.map(d => (
      <DataPointLabel key={d.key ?? d.uniqueId} data={d} />
    ))}
  </g>
);
